import Head from 'next/head';
import {useRouter} from 'next/router';
import React from 'react';

import {HeadSEO, useCanonicalUrl} from '@udemy/head-seo';
import {useStores} from '@udemy/store-provider';

import {getLayout} from 'src/components/layout';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';
import {RootStore} from 'src/stores/root-store';

import {HomeContextData} from '../../types/home-context';
import {HomePageFeature} from './home-page-feature';

export function HomePage() {
    const [rootStore] = useStores([RootStore]);
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl(
        router as {locale: string; asPath: string},
        [],
        META_DEFAULT_BASE_URL,
    );

    return (
        <>
            <HeadSEO
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
                robots={['noindex']}
            />
            <HomePageFeature
                contextData={rootStore.contextData as HomeContextData}
                userOccupationInfo={rootStore.userOccupationInfo}
                hasSeenUserGoalHeader={rootStore.hasSeenUserGoalHeader}
                userEnrollments={rootStore.userEnrollments}
                accelerator={rootStore.accelerator}
                recommendedExam={rootStore.recommendedExam ?? undefined}
                topicSlug={rootStore.topicSlug ?? undefined}
                bundle={rootStore.bundle ?? undefined}
                certification={rootStore.certification ?? undefined}
            />
        </>
    );
}

HomePage.getLayout = getLayout;
